'use client';

import React, { useMemo, useState } from 'react';
import { createContext, useContext } from 'use-context-selector';
import { noop } from 'utils/noop';

export type GlobalErrorContextType = {
  hasGlobalErrorState: boolean;
  setHasGlobalErrorState: (isOffline: boolean) => void;
};
export const GlobalErrorContext = createContext<GlobalErrorContextType>({
  hasGlobalErrorState: false,
  setHasGlobalErrorState: noop,
});

type GlobalErrorContextProviderProps = {
  children?: React.ReactNode;
};

export const GlobalErrorContextProvider = React.memo(
  ({ children }: GlobalErrorContextProviderProps) => {
    const [hasGlobalErrorState, setHasGlobalErrorState] = useState(false);

    const context = useMemo(
      () => ({
        hasGlobalErrorState,
        setHasGlobalErrorState,
      }),
      [hasGlobalErrorState]
    );

    return (
      <GlobalErrorContext.Provider value={context}>
        {children}
      </GlobalErrorContext.Provider>
    );
  }
);

export function useGlobalErrorContext() {
  return useContext(GlobalErrorContext);
}
